import React, { useRef } from "react";
import { Container } from "reactstrap";

import transitionVideo from "./transition.mp4";

function AppLoading({ onLoadingComplete }) {
	const videoRef = useRef(null);
	const handleVideoEnd = () => {
		if (onLoadingComplete) {
			localStorage.setItem("hasVisitedBefore", "true");
			onLoadingComplete();
		}
	};

	const handleVideoError = () => {
		// If video fails to load, proceed after a short delay
		if (onLoadingComplete) {
			onLoadingComplete();
		}
	};

	const handleVideoLoad = () => {
		console.log("Video loaded successfully");
		setTimeout(() => {
			if (videoRef.current) {
				if (videoRef.current && videoRef.current.paused) {
					// Ensure the video starts if it's not playing
					videoRef.current.play().catch(() => {});
				}
			}
		}, 500);
	};

	return (
		<>
			<Container
				className=""
				style={{
					height: "100vh",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					backgroundColor: "#fff",
				}}>
				<video
					ref={videoRef}
					src={transitionVideo}
					autoPlay
					muted
					playsInline
					onEnded={handleVideoEnd}
					onError={handleVideoError}
					onLoadedData={handleVideoLoad}
					style={{
						width: "auto",
						height: "100vh",
						display: "block",
						margin: "0 auto",
					}}>
					Your browser does not support the video tag.
				</video>
			</Container>
		</>
	);
}

export default AppLoading;
